module.exports = __webpack_public_path__ + "static/media/21ECLAC48.ecdb2d65.jpg";